/* eslint-disable jsx-a11y/media-has-caption */

import React, { useState, useRef, useEffect, useCallback } from 'react';
import classNames from 'classnames';
import { useSelector, useDispatch } from 'react-redux';
import { getAppStarted } from '#/redux/modules/lifecycle/selectors';
import routes from '#/utils/routes';
import { sendScreenView } from '#/redux/modules/firestore/actions';
import { splashScreenName } from '#/config/strings';

import { isLowEndDevice, isVIZIO } from '#/utils/componentStyleConfig';
import styles from './SplashScreen.scss';
import splashVideo from './splashVideo.mp4';

const SplashScreen = () => {
  const appStarted = useSelector(getAppStarted);
  const isPlayerRoute = window.location.pathname?.startsWith(
    routes.BASE_PLAYER, // e.g. Deep Link URL
  );
  const isShowDetailsRoute = window.location.pathname?.startsWith(
    routes.BASE_SHOW_DETAILS, // e.g. Deep Link URL
  );
  const [showSplash, setShowSplash] = useState(
    (!appStarted && !isPlayerRoute && !isShowDetailsRoute) || isVIZIO(),
  );
  const [startFadeOut, setStartFadeOut] = useState(false);
  const splashRef = useRef();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(sendScreenView(splashScreenName));
  }, [splashScreenName]);

  const onVideoEnded = useCallback(() => {
    setStartFadeOut(true);
    setShowSplash(isLowEndDevice());
  });

  useEffect(() => {
    if (appStarted && splashRef?.current) {
      const fadeSound = () => {
        if (!splashRef.current) {
          return;
        }

        splashRef.current.volume = Math.max(0, splashRef.current.volume - 0.1);
        if (splashRef.current.volume > 0.7) {
          requestAnimationFrame(fadeSound);
        }
      };
      requestAnimationFrame(fadeSound);
    }
  }, [appStarted, splashRef]);

  return showSplash ? (
    <video
      className={classNames(styles.splashVideo, {
        [styles.fadeOut]: !isLowEndDevice() && startFadeOut,
      })}
      src={splashVideo}
      type="video/mp4"
      autoPlay
      ref={splashRef}
      onEnded={onVideoEnded}
    />
  ) : null;
};

export default SplashScreen;
